"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderDetail = useOrderDetail;
const react_1 = require("react");
const getById_1 = require("../../../modules/orders/app/getById");
const ApiOrderRepo_1 = require("../../../modules/orders/infra/ApiOrderRepo");
const repo = (0, ApiOrderRepo_1.createApiOrderRepo)();
function useOrderDetail(id) {
    const [orderDetail, setOrderDetail] = (0, react_1.useState)(null);
    const fetchOrderDetail = (0, react_1.useCallback)(async () => {
        if (!id)
            return;
        try {
            const data = await (0, getById_1.getById)(repo, id);
            setOrderDetail(data);
        }
        catch (err) {
            console.error('Error fetching order details:', err);
        }
    }, [id]);
    (0, react_1.useEffect)(() => {
        fetchOrderDetail();
    }, [fetchOrderDetail]);
    return {
        orderDetail,
        setOrderDetail,
        fetchOrderDetail,
    };
}
